<template>
  <div>
    <NotificationReminderContainer :feature-name="NOTIFICATION_FEATURES_NAME.PICKUP_PERSON" />
  </div>
</template>

<script>
import NotificationReminderContainer from '@/src/components/Settings/notifications/NotificationReminderContainer.vue'
import NOTIFICATION_FEATURES_NAME from '@src/constants/notification-constants.js'
export default {
  components: {
    NotificationReminderContainer,
  },
  data() {
    return {
      NOTIFICATION_FEATURES_NAME,
    }
  },
}
</script>
